import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/languex-app/src/components/screen/start-order/OrderConfirmation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/languex-app/src/components/screen/start-order/StartOrder.tsx");
